import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  ISO8601DateTime: any;
};

export type Address = {
  __typename?: "Address";
  address1: Scalars["String"];
  address2?: Maybe<Scalars["String"]>;
  city: Scalars["String"];
  company?: Maybe<Scalars["String"]>;
  country: Scalars["String"];
  countryCodeV2: Scalars["String"];
  firstName: Scalars["String"];
  lastName: Scalars["String"];
  latitude?: Maybe<Scalars["String"]>;
  longitude?: Maybe<Scalars["String"]>;
  name: Scalars["String"];
  phone?: Maybe<Scalars["String"]>;
  province?: Maybe<Scalars["String"]>;
  provinceCode?: Maybe<Scalars["String"]>;
  zipcode?: Maybe<Scalars["String"]>;
};

export type Amount = {
  __typename?: "Amount";
  amount: Scalars["Int"];
  currencyCode: Scalars["String"];
  formattedValue: Scalars["String"];
};

export type Cart = {
  __typename?: "Cart";
  billingAddress: Address;
  cartSummary: CartSummary;
  feeBreakdown: Array<FeeBreakdown>;
  lineItems: Array<LineItem>;
  shippingAddress: Address;
  totalQuantity: Scalars["Int"];
};

export type CartSummary = {
  __typename?: "CartSummary";
  discountCodes?: Maybe<Array<Scalars["String"]>>;
  discounts?: Maybe<Array<Discount>>;
  shopNowCredit?: Maybe<Credit>;
  subtotal: Amount;
  tax: Amount;
  total: Amount;
};

export type ChangeRefundMethod = {
  __typename?: "ChangeRefundMethod";
  success: Scalars["Boolean"];
};

export type Checkout = {
  __typename?: "Checkout";
  feeBreakdown: Array<FeeBreakdown>;
  overallCartSummary: CartSummary;
  payment?: Maybe<Payment>;
  refund: Refund;
  returnCart: ReturnCart;
  shopNowCart: Cart;
};

export type CheckoutComplete = {
  __typename?: "CheckoutComplete";
  message: Scalars["String"];
};

export type CheckoutCompleteInput = {
  /** Shopify cart token */
  cartToken: Scalars["String"];
  /** Current shop now session encrypted code */
  code: Scalars["String"];
  /** Payment parameters */
  payment?: InputMaybe<PaymentInput>;
};

export type CheckoutCompleteResult = {
  __typename?: "CheckoutCompleteResult";
  data?: Maybe<CheckoutComplete>;
  errors: Array<UserError>;
};

export type CheckoutResult = {
  __typename?: "CheckoutResult";
  data?: Maybe<Checkout>;
  errors: Array<UserError>;
};

export type ConsumerProfile = {
  __typename?: "ConsumerProfile";
  profileId: Scalars["String"];
};

export type CreateDirectUploadInput = {
  /** File size (bytes) */
  byteSize: Scalars["Int"];
  /** MD5 file checksum as base64 */
  checksum: Scalars["String"];
  /** File content type */
  contentType: Scalars["String"];
  /** Original file name */
  filename: Scalars["String"];
};

export type Credit = {
  __typename?: "Credit";
  total: Amount;
  used: Amount;
};

export type CustomerMutation = {
  __typename?: "CustomerMutation";
  applyDiscountCode: DiscountCodeResult;
  cancelReturn: Scalars["String"];
  changeRefundMethod: ChangeRefundMethod;
  createDirectUpload: DirectUpload;
  emitMetrics: Scalars["Boolean"];
  /** Set user preferences for returns, e.g. preferred return method */
  setUserPreferences: Scalars["String"];
  shopNowAbort: ShopNowAbort;
  shopNowV2Checkout: CheckoutCompleteResult;
  submitReturn: Scalars["String"];
};

export type CustomerMutationApplyDiscountCodeArgs = {
  cartToken: Scalars["String"];
  code: Scalars["String"];
  couponCodes: Array<Scalars["String"]>;
};

export type CustomerMutationCancelReturnArgs = {
  email?: InputMaybe<Scalars["String"]>;
  orderNumber?: InputMaybe<Scalars["String"]>;
  returnId?: InputMaybe<Scalars["String"]>;
  shopId?: InputMaybe<Scalars["String"]>;
};

export type CustomerMutationChangeRefundMethodArgs = {
  note?: InputMaybe<Scalars["String"]>;
  refundMethod: Scalars["String"];
  returnHashid: Scalars["String"];
};

export type CustomerMutationCreateDirectUploadArgs = {
  input: CreateDirectUploadInput;
};

export type CustomerMutationEmitMetricsArgs = {
  metricEmissions: Array<MetricEmissionInput>;
};

export type CustomerMutationSetUserPreferencesArgs = {
  email: Scalars["String"];
  orderId: Scalars["String"];
  userPreferences: UserPreferencesInput;
};

export type CustomerMutationShopNowAbortArgs = {
  refundMethod: Scalars["String"];
  returnId: Scalars["String"];
};

export type CustomerMutationShopNowV2CheckoutArgs = {
  checkout: CheckoutCompleteInput;
};

export type CustomerMutationSubmitReturnArgs = {
  api?: InputMaybe<Scalars["Boolean"]>;
  carrierServiceName?: InputMaybe<Scalars["String"]>;
  csid?: InputMaybe<Scalars["String"]>;
  customerPmtId?: InputMaybe<Scalars["String"]>;
  draftReturnUuid?: InputMaybe<Scalars["String"]>;
  email: Scalars["String"];
  exchangeItems: Array<ExchangeItemInput>;
  fromAddress?: InputMaybe<FromAddressInput>;
  homePickupInstructions?: InputMaybe<Scalars["String"]>;
  locale?: InputMaybe<Scalars["String"]>;
  location?: InputMaybe<DropoffLocationInput>;
  locationId?: InputMaybe<Scalars["String"]>;
  orderNumber: Scalars["String"];
  paymentMethodId?: InputMaybe<Scalars["String"]>;
  paymentProcessorId?: InputMaybe<Scalars["String"]>;
  paymentProvider?: InputMaybe<Scalars["String"]>;
  preApprovalId?: InputMaybe<Scalars["String"]>;
  preApprovalReturnUuid?: InputMaybe<Scalars["String"]>;
  presentmentCurrency: Scalars["String"];
  requestedLabelCount?: InputMaybe<Scalars["Int"]>;
  reshopOptions?: InputMaybe<ReshopOptionsInput>;
  returnItems: Array<ReturnCalculationInput>;
  selectedRefundMethod?: InputMaybe<Scalars["String"]>;
  shippingMethod: Scalars["String"];
  shippingPrice?: InputMaybe<Scalars["Float"]>;
  shopNow?: InputMaybe<Scalars["Boolean"]>;
  shopifyOrderId: Scalars["String"];
};

export type CustomerQuery = {
  __typename?: "CustomerQuery";
  /** Calculates outcomes for various refund methods: original payment, gift card, shop now, etc. Usually the calculated outcome is treated as an estimate, and the actual calculation happens in SubmitReturn. However, the outcomes are persisted, and in the case of shop now abort (SHOPZ-2715), the persisted outcome will be applied. */
  calculateRefund: RefundEstimate;
  checkShopNowExpiration?: Maybe<ShopNowExpiration>;
  /** Returns the configured branding */
  configuredBranding: ShopBranding;
  evenExchangeProduct?: Maybe<SearchItem>;
  /** Returns all available rule definitions for given rule type */
  getReturnRuleConditionDefinitions: Array<ReturnRuleConditionDefinition>;
  /** return all states of a country */
  listStatesOfCountryCode: Array<Region>;
  order?: Maybe<ShopOrder>;
  /** The first use case will be Reshop's "hard" pre-approval (SHOPZ-2531) but we expect there will be other types of pre-approval in the future. */
  preApproval: PreApproval;
  /** Returns History Info */
  returnHistory: Array<Return>;
  /** Returns the configured Return Locations for the shop */
  returnLocations: Array<ReturnLocation>;
  /** Returns the configured Return Methods for the shop */
  returnMethods: Array<ReturnMethod>;
  /** Returns the configured Return Reasons for the shop */
  returnReasons: Array<ReturnReason>;
  shopNowSession?: Maybe<ShopNowSession>;
  shopNowV2Checkout: CheckoutResult;
  /** Returns Tracking Info for a given return ID */
  trackingInfo: TrackingInfo;
  translations: Array<Translation>;
  /** The returns-related user preferences for the given user. See /doc/features/consumer_preferences/overview.md */
  userPreferences: UserPreferences;
};

export type CustomerQueryCalculateRefundArgs = {
  carrierServiceName?: InputMaybe<Scalars["String"]>;
  chosenRefundMethod?: InputMaybe<Scalars["String"]>;
  csid?: InputMaybe<Scalars["String"]>;
  draftReturnUuid?: InputMaybe<Scalars["String"]>;
  email: Scalars["String"];
  exchangeItems: Array<ExchangeItemInput>;
  fromAddress?: InputMaybe<FromAddressInput>;
  locale?: InputMaybe<Scalars["String"]>;
  orderNumber: Scalars["String"];
  presentmentCurrency: Scalars["String"];
  returnItems: Array<ReturnCalculationInput>;
  shippingMethod?: InputMaybe<Scalars["String"]>;
  shippingPrice?: InputMaybe<Scalars["Float"]>;
  shopId?: InputMaybe<Scalars["String"]>;
  shopifyOrderId: Scalars["String"];
  source?: InputMaybe<Scalars["String"]>;
};

export type CustomerQueryCheckShopNowExpirationArgs = {
  cancel?: InputMaybe<Scalars["Boolean"]>;
  code: Scalars["String"];
};

export type CustomerQueryEvenExchangeProductArgs = {
  compareAtPrice?: InputMaybe<Scalars["Float"]>;
  countryCode?: InputMaybe<Scalars["String"]>;
  currency?: InputMaybe<Scalars["String"]>;
  locale?: InputMaybe<Scalars["String"]>;
  price: Scalars["Float"];
  productId: Scalars["String"];
  query: Scalars["String"];
  showProduct?: InputMaybe<Scalars["Boolean"]>;
  variantId?: InputMaybe<Scalars["String"]>;
};

export type CustomerQueryGetReturnRuleConditionDefinitionsArgs = {
  ruleType: Rule;
};

export type CustomerQueryListStatesOfCountryCodeArgs = {
  countryCode: Scalars["String"];
  locale?: InputMaybe<Scalars["String"]>;
};

export type CustomerQueryOrderArgs = {
  csid?: InputMaybe<Scalars["String"]>;
  email: Scalars["String"];
  giftCode?: InputMaybe<Scalars["String"]>;
  guestReturn?: InputMaybe<Scalars["Boolean"]>;
  locale?: InputMaybe<Scalars["String"]>;
  orderNumber: Scalars["String"];
  zipcode?: InputMaybe<Scalars["String"]>;
};

export type CustomerQueryPreApprovalArgs = {
  preApprovalInput: PreApprovalInput;
};

export type CustomerQueryReturnHistoryArgs = {
  email: Scalars["String"];
  orderNumber: Scalars["String"];
};

export type CustomerQueryReturnLocationsArgs = {
  carrier: Scalars["String"];
  consolidationRadius?: InputMaybe<Scalars["Int"]>;
  countryCode: Scalars["String"];
  locale?: InputMaybe<Scalars["String"]>;
  qr?: InputMaybe<Scalars["String"]>;
  zipcode: Scalars["String"];
};

export type CustomerQueryReturnMethodsArgs = {
  chosenRefundMethod?: InputMaybe<Scalars["String"]>;
  csid?: InputMaybe<Scalars["String"]>;
  draftReturnUuid?: InputMaybe<Scalars["String"]>;
  email: Scalars["String"];
  exchangeItems: Array<ExchangeItemInput>;
  fromAddress?: InputMaybe<FromAddressInput>;
  locale?: InputMaybe<Scalars["String"]>;
  orderNumber: Scalars["String"];
  presentmentCurrency?: InputMaybe<Scalars["String"]>;
  returnItems: Array<ReturnCalculationInput>;
  shopId?: InputMaybe<Scalars["String"]>;
  shopifyOrderId?: InputMaybe<Scalars["String"]>;
};

export type CustomerQueryReturnReasonsArgs = {
  limit?: InputMaybe<Scalars["Int"]>;
  locale?: InputMaybe<Scalars["String"]>;
  offset?: InputMaybe<Scalars["Int"]>;
};

export type CustomerQueryShopNowSessionArgs = {
  code: Scalars["String"];
};

export type CustomerQueryShopNowV2CheckoutArgs = {
  cartToken: Scalars["String"];
  code: Scalars["String"];
};

export type CustomerQueryTrackingInfoArgs = {
  returnId: Scalars["String"];
  trackingNumber: Scalars["String"];
};

export type CustomerQueryTranslationsArgs = {
  categories: Array<Scalars["String"]>;
  locale?: InputMaybe<Scalars["String"]>;
};

export type CustomerQueryUserPreferencesArgs = {
  email: Scalars["String"];
};

/** Represents direct upload credentials */
export type DirectUpload = {
  __typename?: "DirectUpload";
  /** Created blob record ID */
  blobId: Scalars["ID"];
  /** HTTP request headers (JSON-encoded) */
  headers: Scalars["String"];
  /** Created blob record signed ID */
  signedBlobId: Scalars["ID"];
  /** Upload URL */
  url: Scalars["String"];
};

export type Discount = {
  __typename?: "Discount";
  discountAmount: Amount;
  targetType: Scalars["String"];
};

export type DiscountCodeResult = {
  __typename?: "DiscountCodeResult";
  data?: Maybe<Scalars["String"]>;
  errors: Array<UserError>;
};

export type DisplayStateTransition = {
  __typename?: "DisplayStateTransition";
  byUser?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  rmaEnabled?: Maybe<Scalars["Boolean"]>;
  status?: Maybe<Scalars["String"]>;
  timelineItemType: Scalars["String"];
  timestamp?: Maybe<Scalars["String"]>;
};

/** Dropoff Location. See doc/features/locations/drop_off_locations.md */
export type DropoffLocationInput = {
  id?: InputMaybe<Scalars["String"]>;
  latitude?: InputMaybe<Scalars["Float"]>;
  logoUrl?: InputMaybe<Scalars["String"]>;
  longitude?: InputMaybe<Scalars["Float"]>;
  storeAddress?: InputMaybe<GenericAddressInput>;
  storeName?: InputMaybe<Scalars["String"]>;
  storeName2?: InputMaybe<Scalars["String"]>;
};

/** Exchange Item Input Type */
export type ExchangeItemInput = {
  newProductId: Scalars["String"];
  newProductImage?: InputMaybe<Scalars["String"]>;
  newProductName?: InputMaybe<Scalars["String"]>;
  newProductPriceAmount?: InputMaybe<Scalars["Float"]>;
  newProductPriceCurrency?: InputMaybe<Scalars["String"]>;
  newProductSku?: InputMaybe<Scalars["String"]>;
  newProductVariantId: Scalars["String"];
  newProductVariantInfo: Array<ExchangeItemVariantInfo>;
  returnItem: ReturnCalculationInput;
};

export type ExchangeItemVariantInfo = {
  name: Scalars["String"];
  value: Scalars["String"];
};

export type Fee = {
  __typename?: "Fee";
  /** Three-letter code, ISO-4217. Example: "BHD" */
  currency: Scalars["String"];
  /** Examples: "Return Fee", "Frais de retour par défaut" */
  description?: Maybe<Scalars["String"]>;
  displayWithReturnMethod?: Maybe<Scalars["Boolean"]>;
  /** Currency subunit. Example: 123.0 means $1.23 */
  fee: Scalars["Float"];
  /** The type of fee this represents: "shipping", "handling", or "return" */
  feeType?: Maybe<Scalars["String"]>;
  formattedFee?: Maybe<Scalars["String"]>;
  formattedFeeWithCurrency?: Maybe<Scalars["String"]>;
  /** See "tax_code" in doc/features/shop_automation/refund/fees.md */
  taxCode?: Maybe<Scalars["String"]>;
};

export type FeeBreakdown = {
  __typename?: "FeeBreakdown";
  amount: Scalars["Float"];
  currencyCode: Scalars["String"];
  description: Scalars["String"];
  displayWithReturnMethod: Scalars["Boolean"];
  formattedValue: Scalars["String"];
  shopNowClawback: Scalars["Boolean"];
  taxCode?: Maybe<Scalars["String"]>;
};

/** Return Method input */
export type FromAddressInput = {
  address1: Scalars["String"];
  address2?: InputMaybe<Scalars["String"]>;
  city: Scalars["String"];
  company?: InputMaybe<Scalars["String"]>;
  country?: InputMaybe<Scalars["String"]>;
  countryCode?: InputMaybe<Scalars["String"]>;
  countryCodeV2: Scalars["String"];
  firstName: Scalars["String"];
  lastName: Scalars["String"];
  name?: InputMaybe<Scalars["String"]>;
  phone?: InputMaybe<Scalars["String"]>;
  province?: InputMaybe<Scalars["String"]>;
  provinceCode?: InputMaybe<Scalars["String"]>;
  zip: Scalars["String"];
};

/** Generic Address */
export type GenericAddressInput = {
  address1: Scalars["String"];
  address2?: InputMaybe<Scalars["String"]>;
  city: Scalars["String"];
  company?: InputMaybe<Scalars["String"]>;
  country?: InputMaybe<Scalars["String"]>;
  countryCode?: InputMaybe<Scalars["String"]>;
  countryCodeV2?: InputMaybe<Scalars["String"]>;
  firstName?: InputMaybe<Scalars["String"]>;
  lastName?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  phone?: InputMaybe<Scalars["String"]>;
  province?: InputMaybe<Scalars["String"]>;
  provinceCode?: InputMaybe<Scalars["String"]>;
  state?: InputMaybe<Scalars["String"]>;
  zip: Scalars["String"];
};

export type LineItem = {
  __typename?: "LineItem";
  cost: LineItemCost;
  discounts: Array<Discount>;
  id?: Maybe<Scalars["String"]>;
  imageUrl?: Maybe<Scalars["String"]>;
  name: Scalars["String"];
  price: Amount;
  productId: Scalars["String"];
  quantity: Scalars["Int"];
  title: Scalars["String"];
  variantId: Scalars["String"];
};

export type LineItemCost = {
  __typename?: "LineItemCost";
  amountPerQuantity: Amount;
  discountedAmountPerQuantity: Amount;
  subtotal: Amount;
  total: Amount;
};

export type MetricEmissionInput = {
  /**
   *         Must use ISO-4217 3-Alpha. If a code is given, value will be converted
   *         to USD (whole dollars), and “_usd” will be appended to the final metric
   *         name.
   *
   */
  currencyCode?: InputMaybe<Scalars["String"]>;
  /**
   *         Must match /^[_a-z]+$/. Given a suffix "foo", the final
   *         metric name will be "narvar.zero.shopify.frontend.foo".
   *
   */
  metricNameSuffix: Scalars["String"];
  /**
   *         For now, must be "count". In the future, other metric types may be
   *         supported.
   *
   */
  metricType: Scalars["String"];
  /**
   *         Fractional monetary values, eg. cents, are not supported. Round off to
   *         the nearest whole currency unit, e.g. dollar.
   *
   */
  value: Scalars["Int"];
};

/** A monetary value */
export type Money = {
  __typename?: "Money";
  /** Value in smallest currency unit, e.g. JPY */
  cents: Scalars["Int"];
  /** 3-character currency code */
  currency: Scalars["String"];
  /** Value in dollars */
  dollars: Scalars["Float"];
  /** Display string of the value */
  formattedAmount: Scalars["String"];
};

/** A monetary value */
export type MoneyInput = {
  /** Value in smallest currency unit, e.g. JPY */
  cents: Scalars["Int"];
  /** 3-character currency code */
  currency: Scalars["String"];
};

export type Payment = {
  __typename?: "Payment";
  customerPmtId: Scalars["String"];
  paymentClientSecret: Scalars["String"];
  paymentGateway?: Maybe<Scalars["String"]>;
  paymentGatewayDisplay?: Maybe<Scalars["String"]>;
  paymentProcessorId: Scalars["String"];
  paymentProcessorPubKey?: Maybe<Scalars["String"]>;
  paymentProvider: Scalars["String"];
  paymentRef?: Maybe<Scalars["String"]>;
  value: Amount;
};

export type PaymentInput = {
  /** Payment gateway i.e stripe */
  gateway: Scalars["String"];
  /** Payment intent id */
  paymentIntentId: Scalars["String"];
  /** Payment processor id */
  paymentProcessorId: Scalars["String"];
  /** Payment provider i.e stripe, narvar */
  paymentProvider: Scalars["String"];
};

export type PreApproval = {
  __typename?: "PreApproval";
  result?: Maybe<PreApprovalResult>;
  userErrors: Array<UserError>;
};

export type PreApprovalInput = {
  email: Scalars["String"];
  exchangeItems: Array<ExchangeItemInput>;
  orderNumber: Scalars["String"];
  /** A UUID identifying the nascent Return. For Reshop, this is used as the external_id. Prior to SHOPZ-2531, we used the RMA number as the external_id. Now we must use a UUID, because the RMA number has not yet been generated. */
  preApprovalReturnUuid: Scalars["String"];
  /** The value, from calculateRefund, of the refund method selected by the consumer */
  refundCalculated: MoneyInput;
  reshopOptions?: InputMaybe<ReshopOptionsInput>;
  returnItems: Array<ReturnCalculationInput>;
};

export type PreApprovalResult = {
  __typename?: "PreApprovalResult";
  /** The ID provided by the relevant pre-approval feature, e.g. Reshop */
  preApprovalId: Scalars["String"];
};

export type ProductVariantOptions = {
  __typename?: "ProductVariantOptions";
  name: Scalars["String"];
  position: Scalars["Int"];
  values: Array<Scalars["String"]>;
};

export type Refund = {
  __typename?: "Refund";
  refundMethod: Scalars["String"];
  refundMethodDescription: Scalars["String"];
  refundMethodDisplay: Scalars["String"];
  value: Amount;
};

export type RefundEstimate = {
  __typename?: "RefundEstimate";
  chosenRefundMethod?: Maybe<Scalars["String"]>;
  connectedStripeAccount?: Maybe<Scalars["String"]>;
  currency: Scalars["String"];
  customerPmtId?: Maybe<Scalars["String"]>;
  exchangeShippingFeeDisplayName?: Maybe<Scalars["String"]>;
  exchangeShippingFeeDisplayPrice?: Maybe<Scalars["String"]>;
  feeBreakdown: Array<Fee>;
  giftCardTotalRefund?: Maybe<Scalars["String"]>;
  giftCardTotalRefundCents?: Maybe<Scalars["Float"]>;
  originalPaymentTotalRefund?: Maybe<Scalars["String"]>;
  originalPaymentTotalRefundCents?: Maybe<Scalars["Float"]>;
  originalShippingRefunded?: Maybe<Scalars["String"]>;
  originalShippingRefundedDisplayAmt?: Maybe<Scalars["String"]>;
  paymentClientSecret?: Maybe<Scalars["String"]>;
  paymentProcessorId?: Maybe<Scalars["String"]>;
  paymentProcessorPubKey?: Maybe<Scalars["String"]>;
  paymentProvider?: Maybe<Scalars["String"]>;
  paymentRef?: Maybe<Scalars["String"]>;
  preChargeFeeAmountCents?: Maybe<Scalars["Float"]>;
  priorRefundsDisplayAmt?: Maybe<Scalars["String"]>;
  refundLineItems: Array<RefundLineItem>;
  refundMethodsAvailable?: Maybe<Array<RefundMethod>>;
  returnMethodDisplayPrice?: Maybe<Scalars["String"]>;
  shippingCost: Scalars["String"];
  shopNowAvailable?: Maybe<Scalars["Boolean"]>;
  shopNowTotalRefund?: Maybe<Scalars["String"]>;
  shopNowTotalRefundCents?: Maybe<Scalars["Float"]>;
  subtotalRefund: Scalars["String"];
  subtotalRefundCents: Scalars["Float"];
  taxesIncluded: Scalars["Boolean"];
  totalRefund: Scalars["String"];
  totalRefundCents: Scalars["Float"];
  totalTax: Scalars["String"];
  totalTaxDisplayAmt: Scalars["String"];
  transactions: Array<RefundTransaction>;
};

export type RefundLineItem = {
  __typename?: "RefundLineItem";
  discountedPrice: Scalars["String"];
  lineItemId: Scalars["String"];
  locationId?: Maybe<Scalars["String"]>;
  price: Scalars["String"];
  quantity: Scalars["Int"];
  refundTotalPrice: Scalars["String"];
  restockType: Scalars["String"];
  subtotal: Scalars["String"];
  totalCartDiscountAmount: Scalars["String"];
  totalTax: Scalars["String"];
};

export type RefundMethod = {
  __typename?: "RefundMethod";
  refundCents?: Maybe<Scalars["Int"]>;
  refundFormatted?: Maybe<Scalars["String"]>;
  refundMethod: Scalars["String"];
  refundMethodDescription: Scalars["String"];
  /**
   * gift_card or reshop. The frontend will use this information to visually distinguish a Reshop Refund Method from the normal gift-card Refund Method.
   * @deprecated As of SHOPZ-2516, use refund_method instead
   */
  refundMethodGiftCardType?: Maybe<Scalars["String"]>;
};

export type RefundTransaction = {
  __typename?: "RefundTransaction";
  amount: Scalars["String"];
  currency: Scalars["String"];
  gateway: Scalars["String"];
  maximumRefundable: Scalars["String"];
  parentId: Scalars["String"];
};

export type Region = {
  __typename?: "Region";
  region: Scalars["String"];
  regionCode: Scalars["String"];
};

/** Reshop Options input */
export type ReshopOptionsInput = {
  customerPhone?: InputMaybe<Scalars["String"]>;
  smsUpdates: Scalars["Boolean"];
};

export type Return = {
  __typename?: "Return";
  amountFromPriorRefunds?: Maybe<Scalars["String"]>;
  availableStatuses?: Maybe<Array<Scalars["String"]>>;
  cancellable?: Maybe<Scalars["Boolean"]>;
  carrierTrackingNumber?: Maybe<Scalars["String"]>;
  currentStatus: Scalars["String"];
  customerEmail?: Maybe<Scalars["String"]>;
  customerName?: Maybe<Scalars["String"]>;
  customerPhone?: Maybe<Scalars["String"]>;
  displayError?: Maybe<ReturnDashboardDisplayError>;
  displayStateTransitions?: Maybe<Array<DisplayStateTransition>>;
  errorMessage?: Maybe<Scalars["String"]>;
  exchangeDraftOrderId?: Maybe<Scalars["String"]>;
  exchangeOrderId?: Maybe<Scalars["String"]>;
  /** Frontend-safe subset of the shop flags at the time the return was created */
  featureFlags?: Maybe<Array<Scalars["String"]>>;
  feeBreakdown?: Maybe<Array<Fee>>;
  guestReturn?: Maybe<Scalars["Boolean"]>;
  id: Scalars["String"];
  isClaim?: Maybe<Scalars["Boolean"]>;
  isCsInitiated?: Maybe<Scalars["Boolean"]>;
  isNarvarExchangeCreditOrder?: Maybe<Scalars["Boolean"]>;
  isShopNowReturn?: Maybe<Scalars["Boolean"]>;
  lastModified: Scalars["ISO8601DateTime"];
  notes?: Maybe<Scalars["String"]>;
  orderDate: Scalars["ISO8601DateTime"];
  orderId?: Maybe<Scalars["String"]>;
  originalShippingRefundedValue: Scalars["String"];
  paymentCaptured?: Maybe<Scalars["Boolean"]>;
  paymentRequired?: Maybe<Scalars["Boolean"]>;
  preChargeFeeAmount?: Maybe<Scalars["String"]>;
  previousVersions?: Maybe<Array<ReturnVersion>>;
  qrCodeUrl?: Maybe<Scalars["String"]>;
  refundAmountCurrency?: Maybe<Scalars["String"]>;
  refundAutomationState?: Maybe<ReturnRefundAutomationState>;
  refundMethod?: Maybe<Scalars["String"]>;
  refundSubtotalDisplayValue: Scalars["String"];
  refundTotalDisplayValue: Scalars["String"];
  reshopRefundId?: Maybe<Scalars["String"]>;
  returnDate?: Maybe<Scalars["ISO8601DateTime"]>;
  returnItems: Array<ReturnItem>;
  /** URL of PDF containing the PSSLs from each ReturnShipment, concatenated. Null for non-carrier returns, like return_in_store, and keep_the_item. */
  returnLabel?: Maybe<Scalars["String"]>;
  returnMethod?: Maybe<Scalars["String"]>;
  returnMethodCarrierService?: Maybe<Scalars["String"]>;
  returnShipments: Array<ReturnShipment>;
  returnStatusUpdatedAt?: Maybe<Scalars["ISO8601DateTime"]>;
  rmaNumber?: Maybe<Scalars["String"]>;
  shippingFeesDisplayValue: Scalars["String"];
  shopifyOrderId: Scalars["String"];
  taxDisplayValue: Scalars["String"];
};

/** Return Method input */
export type ReturnCalculationInput = {
  childReturnReason?: InputMaybe<Scalars["String"]>;
  childReturnReasonId?: InputMaybe<Scalars["String"]>;
  comment?: InputMaybe<Scalars["String"]>;
  lineItemId: Scalars["String"];
  pictures?: InputMaybe<Array<Scalars["String"]>>;
  quantity: Scalars["Int"];
  returnReason: Scalars["String"];
  returnReasonId: Scalars["String"];
};

export type ReturnCart = {
  __typename?: "ReturnCart";
  cartSummary: CartSummary;
  feeBreakdown: Array<FeeBreakdown>;
  lineItems: Array<ReturnLineItem>;
};

export type ReturnDashboardDisplayError = {
  __typename?: "ReturnDashboardDisplayError";
  message?: Maybe<Scalars["String"]>;
  timestamp?: Maybe<Scalars["String"]>;
};

export type ReturnItem = {
  __typename?: "ReturnItem";
  childReturnReasonCode?: Maybe<Scalars["String"]>;
  comment?: Maybe<Scalars["String"]>;
  customerPictures?: Maybe<Array<Scalars["String"]>>;
  displayTotalIncludingTaxAndDuties?: Maybe<Scalars["String"]>;
  id: Scalars["String"];
  isExchange?: Maybe<Scalars["Boolean"]>;
  itemId?: Maybe<Scalars["String"]>;
  itemName?: Maybe<Scalars["String"]>;
  itemReturnStatus: Array<ReturnItemStatus>;
  newProductImage?: Maybe<Scalars["String"]>;
  newProductName?: Maybe<Scalars["String"]>;
  newProductSku?: Maybe<Scalars["String"]>;
  productId?: Maybe<Scalars["String"]>;
  productImageUrl?: Maybe<Scalars["String"]>;
  purchasePrice?: Maybe<Scalars["String"]>;
  quantity?: Maybe<Scalars["Int"]>;
  refundPrice?: Maybe<Scalars["String"]>;
  returnReason?: Maybe<Scalars["String"]>;
  returnReasonCode?: Maybe<Scalars["String"]>;
  sku?: Maybe<Scalars["String"]>;
  variantId?: Maybe<Scalars["String"]>;
};

export type ReturnItemStatus = {
  __typename?: "ReturnItemStatus";
  qty?: Maybe<Scalars["Int"]>;
  status?: Maybe<Scalars["String"]>;
  updatedAt?: Maybe<Scalars["ISO8601DateTime"]>;
};

export type ReturnItemVersion = {
  __typename?: "ReturnItemVersion";
  /** The time of version-record creation. */
  createdAt: Scalars["ISO8601DateTime"];
  id: Scalars["String"];
  /** The attributes of the ReturnItem at the time of version-record creation */
  item: ReturnItemVersionItem;
};

/** The attributes of the ReturnItem at the time of version-record creation */
export type ReturnItemVersionItem = {
  __typename?: "ReturnItemVersionItem";
  childReturnReason?: Maybe<Scalars["String"]>;
  childReturnReasonCode?: Maybe<Scalars["String"]>;
  comment?: Maybe<Scalars["String"]>;
  isExchange?: Maybe<Scalars["Boolean"]>;
  keepItem?: Maybe<Scalars["Boolean"]>;
  name?: Maybe<Scalars["String"]>;
  newProductId?: Maybe<Scalars["String"]>;
  newProductName?: Maybe<Scalars["String"]>;
  newProductSku?: Maybe<Scalars["String"]>;
  newProductVariantId?: Maybe<Scalars["String"]>;
  originalReturnReason?: Maybe<Scalars["String"]>;
  productType?: Maybe<Scalars["String"]>;
  quantity?: Maybe<Scalars["Int"]>;
  refundLineItemSubtotal?: Maybe<Scalars["String"]>;
  refundLineItemTotalCartDiscountAmount?: Maybe<Scalars["String"]>;
  refundLineItemTotalTax?: Maybe<Scalars["String"]>;
  returnReason?: Maybe<Scalars["String"]>;
  returnReasonCode?: Maybe<Scalars["String"]>;
  shopifyItemId?: Maybe<Scalars["String"]>;
  shopifyVariantId?: Maybe<Scalars["String"]>;
  sku?: Maybe<Scalars["String"]>;
  unitDiscountPresentmentAmount?: Maybe<Scalars["String"]>;
  unitDiscountShopAmount?: Maybe<Scalars["String"]>;
  unitDiscountedPresentmentAmount?: Maybe<Scalars["String"]>;
  unitDiscountedShopAmount?: Maybe<Scalars["String"]>;
  unitFinalPresentmentAmount?: Maybe<Scalars["String"]>;
  unitFinalShopAmount?: Maybe<Scalars["String"]>;
  unitOriginalPresentmentAmount?: Maybe<Scalars["String"]>;
  unitOriginalShopAmount?: Maybe<Scalars["String"]>;
  unitPrice?: Maybe<Scalars["String"]>;
  unitTaxAndDutyRefundPresentmentAmount?: Maybe<Scalars["String"]>;
  unitTaxAndDutyRefundShopAmount?: Maybe<Scalars["String"]>;
};

export type ReturnLineItem = {
  __typename?: "ReturnLineItem";
  id: Scalars["String"];
  imageUrl?: Maybe<Scalars["String"]>;
  name: Scalars["String"];
  price: Amount;
  productId: Scalars["String"];
  quantity: Scalars["Int"];
  returnReason: ReturnReasonHash;
  title: Scalars["String"];
  variantId: Scalars["String"];
};

export type ReturnLocation = {
  __typename?: "ReturnLocation";
  acceptInStoreReturns: Scalars["Boolean"];
  acceptMailInReturns: Scalars["Boolean"];
  id: Scalars["String"];
  latitude?: Maybe<Scalars["Float"]>;
  logoUrl?: Maybe<Scalars["String"]>;
  longitude?: Maybe<Scalars["Float"]>;
  shopifyLocationId?: Maybe<Scalars["String"]>;
  storeAddress?: Maybe<ReturnLocationAddress>;
  storeDistance?: Maybe<Scalars["String"]>;
  storeName?: Maybe<Scalars["String"]>;
  storeName2?: Maybe<Scalars["String"]>;
};

export type ReturnLocationAddress = {
  __typename?: "ReturnLocationAddress";
  address1?: Maybe<Scalars["String"]>;
  address2?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  latitude?: Maybe<Scalars["String"]>;
  longitude?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
  state?: Maybe<Scalars["String"]>;
  zip?: Maybe<Scalars["String"]>;
};

export type ReturnMethod = {
  __typename?: "ReturnMethod";
  carrierId?: Maybe<Scalars["String"]>;
  /** The name of a carrier (e.g. "USPS" for "usps_returns"). Nullable when doing return in store. */
  carrierName?: Maybe<Scalars["String"]>;
  /** The name of a carrier's service type ex. 'UPS Mail Innovations'. Nullable when doing return in store. */
  carrierService?: Maybe<Scalars["String"]>;
  /** The radius in miles for consolidation. Will be used in GetReturnLocations query to get all return location within this radius. */
  consolidationRadius?: Maybe<Scalars["Int"]>;
  displayDescription: Scalars["String"];
  /** The display name of the return method e.g. "Drop Off at the Post Office", "Return in Store", "Use My Own Carrier". */
  displayName: Scalars["String"];
  displayPrice?: Maybe<Scalars["String"]>;
  feeBreakdown: Array<Fee>;
  id: Scalars["ID"];
  keepAllItems: Scalars["Boolean"];
  keepItemIds?: Maybe<Array<Scalars["String"]>>;
  /** Max labels the consumer is allowed to request. See multi_label_consumer_request feature flag. Value is nil when this shop setting does not apply to this return method, for example Ship on Your Own. */
  maxLabelRequests?: Maybe<Scalars["Int"]>;
  price: Scalars["Float"];
  qr?: Maybe<Scalars["String"]>;
  returnMethodDisplayPrice?: Maybe<Scalars["String"]>;
  shouldDisplayLocations: Scalars["Boolean"];
};

export type ReturnReason = {
  __typename?: "ReturnReason";
  /** The translated attestation text for consumer UI */
  attestation?: Maybe<Scalars["String"]>;
  /** The default attestation translation record */
  attestationTranslation?: Maybe<Translation>;
  claimType?: Maybe<Scalars["String"]>;
  csOnly: Scalars["Boolean"];
  enableCustomerPictures?: Maybe<Scalars["Boolean"]>;
  id: Scalars["String"];
  isCommentMandatory: Scalars["Boolean"];
  isCommon: Scalars["Boolean"];
  isValid: Scalars["Boolean"];
  maxDaysSinceCreation?: Maybe<Scalars["Int"]>;
  maxDaysSinceDelivery?: Maybe<Scalars["Int"]>;
  maxDaysSinceFulfilment?: Maybe<Scalars["Int"]>;
  minDaysSinceCreation?: Maybe<Scalars["Int"]>;
  minDaysSinceDelivery?: Maybe<Scalars["Int"]>;
  minDaysSinceFulfilment?: Maybe<Scalars["Int"]>;
  parentId?: Maybe<Scalars["String"]>;
  priority?: Maybe<Scalars["String"]>;
  /** Reason only shown for matching products */
  productFilters: Array<Scalars["String"]>;
  /** @deprecated Use product_filters instead */
  productTags?: Maybe<Array<Scalars["String"]>>;
  promptQuestion?: Maybe<Scalars["String"]>;
  randomize?: Maybe<Scalars["Boolean"]>;
  reasonTitle: Scalars["String"];
  requireCustomerPictures?: Maybe<Scalars["Boolean"]>;
  shopId: Scalars["Int"];
  shopifyReturnReason?: Maybe<Scalars["String"]>;
  translatedReason?: Maybe<Scalars["String"]>;
};

export type ReturnReasonHash = {
  __typename?: "ReturnReasonHash";
  id: Scalars["String"];
  name: Scalars["String"];
};

export type ReturnRefundAutomationState = {
  __typename?: "ReturnRefundAutomationState";
  closeReturnOnShopifyOrderFailedAt?: Maybe<Scalars["String"]>;
  closeReturnOnShopifyOrderSucceededAt?: Maybe<Scalars["String"]>;
  closeReturnOnShopifyOrderTiming?: Maybe<Scalars["String"]>;
  markAsPaidFailedAt?: Maybe<Scalars["String"]>;
  markAsPaidSucceededAt?: Maybe<Scalars["String"]>;
  markAsPaidTiming?: Maybe<Scalars["String"]>;
  outOfStockRefundAt?: Maybe<Scalars["String"]>;
  refundFailedAt?: Maybe<Scalars["String"]>;
  refundSucceededAt?: Maybe<Scalars["String"]>;
  refundTiming?: Maybe<Scalars["String"]>;
  reserveInventoryFailedAt?: Maybe<Scalars["String"]>;
  reserveInventorySucceededAt?: Maybe<Scalars["String"]>;
  reserveInventoryTiming?: Maybe<Scalars["String"]>;
  restockFailedAt?: Maybe<Scalars["String"]>;
  restockSucceededAt?: Maybe<Scalars["String"]>;
  restockTiming?: Maybe<Scalars["String"]>;
  shopifyReturnApiFfEnabled?: Maybe<Scalars["Boolean"]>;
  shouldRefundWhenOutOfStock: Scalars["Boolean"];
};

export type ReturnRuleConditionDefinition = {
  __typename?: "ReturnRuleConditionDefinition";
  attribute: Scalars["String"];
  attributeDisplayText: Scalars["String"];
  autocomplete?: Maybe<Scalars["String"]>;
  prequalifier: Scalars["String"];
  prequalifierDisplayText: Scalars["String"];
  valueType: RuleValue;
};

export type ReturnShipment = {
  __typename?: "ReturnShipment";
  /** Hashed ID. e.g. 123ABC456 */
  id: Scalars["String"];
  /** e.g. a, b, c. Used on PSSLs. */
  letter: Scalars["String"];
  /** e.g. fedex, cycleon, or keep_the_item */
  returnMethodId: Scalars["String"];
  /** e.g. usps_returns, cycleon. Null for non-carrier return methods, e.g. ship_on_your_own */
  returnTrackingCompany?: Maybe<Scalars["String"]>;
  /** Tracking link  */
  returnTrackingLink?: Maybe<Scalars["String"]>;
  /** Carrier tracking number. Null for non-carrier return methods, e.g. ship_on_your_own */
  returnTrackingNumber?: Maybe<Scalars["String"]>;
  /** Recorded only by shipment strategies that are fulfillment-based, like OneShipmentPerFulfillment. For now, intended only for troubleshooting purposes, but we might use it in the future on the Return Details page, if we decide to display ReturnShipment details there. */
  shopifyFulfillmentId?: Maybe<Scalars["String"]>;
  /** e.g. initiated, on_its_way_to_retailer */
  status: Scalars["String"];
};

export type ReturnVersion = {
  __typename?: "ReturnVersion";
  /** The time of version-record creation. */
  createdAt: Scalars["ISO8601DateTime"];
  id: Scalars["String"];
  /** The attributes of the return at the time of version-record creation */
  return: ReturnVersionReturn;
  returnId: Scalars["String"];
  /** Present when the RMA Edit was performed by a person (not an automation) and RBAC is enabled */
  shopifyUserId?: Maybe<Scalars["Int"]>;
};

/** The attributes of the return at the time of version-record creation */
export type ReturnVersionReturn = {
  __typename?: "ReturnVersionReturn";
  carrier?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["ISO8601DateTime"]>;
  customerEmail?: Maybe<Scalars["String"]>;
  customerLocale?: Maybe<Scalars["String"]>;
  exchangeDraftOrderId?: Maybe<Scalars["Int"]>;
  exchangeOrderId?: Maybe<Scalars["Int"]>;
  exchangeShippingFee?: Maybe<Scalars["String"]>;
  feeBreakdown?: Maybe<Array<Fee>>;
  feesApplied?: Maybe<Scalars["String"]>;
  firstScanDate?: Maybe<Scalars["ISO8601DateTime"]>;
  guestReturn?: Maybe<Scalars["Boolean"]>;
  isShopNowReturn?: Maybe<Scalars["Boolean"]>;
  issuedRefundId?: Maybe<Scalars["String"]>;
  items: Array<ReturnItemVersion>;
  merchantCommentText?: Maybe<Scalars["String"]>;
  merchantRma?: Maybe<Scalars["String"]>;
  originalShippingRefundAmount?: Maybe<Scalars["String"]>;
  paymentMethodId?: Maybe<Scalars["String"]>;
  priorRefundsAmount?: Maybe<Scalars["String"]>;
  receiptDate?: Maybe<Scalars["ISO8601DateTime"]>;
  refundAmount?: Maybe<Scalars["String"]>;
  refundMethod?: Maybe<Scalars["String"]>;
  returnStatus?: Maybe<Scalars["String"]>;
  rmaNumber?: Maybe<Scalars["String"]>;
  shopifyOrderId?: Maybe<Scalars["String"]>;
  warehouseReceiptDate?: Maybe<Scalars["ISO8601DateTime"]>;
};

export enum Rule {
  RefundMethod = "REFUND_METHOD",
  ReturnCost = "RETURN_COST",
  ReturnEligibility = "RETURN_ELIGIBILITY",
  ReturnItemOverage = "RETURN_ITEM_OVERAGE",
  ReturnMethod = "RETURN_METHOD",
}

export enum RuleValue {
  Boolean = "BOOLEAN",
  Datetime = "DATETIME",
  Float = "FLOAT",
  Integer = "INTEGER",
  LessThanInteger = "LESS_THAN_INTEGER",
  List = "LIST",
  Region = "REGION",
  String = "STRING",
  ValueOverLimit = "VALUE_OVER_LIMIT",
  ValueOverLimitDays = "VALUE_OVER_LIMIT_DAYS",
  ValueOverLimitOrders = "VALUE_OVER_LIMIT_ORDERS",
  ValueOverLimitReturns = "VALUE_OVER_LIMIT_RETURNS",
  ValueOverLimitSpend = "VALUE_OVER_LIMIT_SPEND",
}

export type SearchItem = {
  __typename?: "SearchItem";
  descriptionHtml: Scalars["String"];
  id: Scalars["String"];
  name: Scalars["String"];
  options?: Maybe<Array<ProductVariantOptions>>;
  productImageAltTxt?: Maybe<Scalars["String"]>;
  productImageUrl?: Maybe<Scalars["String"]>;
  variantInfo?: Maybe<Array<VariantInfo>>;
};

export type ShopBranding = {
  __typename?: "ShopBranding";
  backgroundImage?: Maybe<Scalars["String"]>;
  backgroundImageUrl?: Maybe<Scalars["String"]>;
  baseBodyTextSize?: Maybe<Scalars["Int"]>;
  bodyBackground?: Maybe<Scalars["String"]>;
  bodyText?: Maybe<Scalars["String"]>;
  borderRadius?: Maybe<Scalars["Int"]>;
  brandPrimary?: Maybe<Scalars["String"]>;
  brandSecondary?: Maybe<Scalars["String"]>;
  customCss?: Maybe<Scalars["String"]>;
  errorColor?: Maybe<Scalars["String"]>;
  errorTextColor?: Maybe<Scalars["String"]>;
  fixedAppBar?: Maybe<Scalars["Boolean"]>;
  fontName?: Maybe<Scalars["String"]>;
  fontUrl?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  isLinkAllCaps?: Maybe<Scalars["Boolean"]>;
  isLinkUnderlined?: Maybe<Scalars["Boolean"]>;
  logoImage?: Maybe<Scalars["String"]>;
  mailFromName?: Maybe<Scalars["String"]>;
  marketingImage?: Maybe<Scalars["String"]>;
  primaryFont?: Maybe<Scalars["String"]>;
  rootMarginBottom?: Maybe<Scalars["Int"]>;
  rootMarginTop?: Maybe<Scalars["Int"]>;
  secondaryFont?: Maybe<Scalars["String"]>;
  stepDelimiterPosition?: Maybe<Scalars["Int"]>;
};

export type ShopItem = {
  __typename?: "ShopItem";
  compareAtPriceAmount?: Maybe<Scalars["Float"]>;
  /** If the order line_item is eligible for delivery protection. Evaluated from Assist order eligibility api */
  deliveryProtectionCovered: Scalars["Boolean"];
  displayCompareAtPrice?: Maybe<Scalars["String"]>;
  displayPrice: Scalars["String"];
  displayPriceTotal: Scalars["String"];
  eligibilityCriteria?: Maybe<Array<ShopItemReturnRule>>;
  hideDisplayPrice: Scalars["Boolean"];
  id: Scalars["String"];
  isExchangesEnabled: Scalars["Boolean"];
  name: Scalars["String"];
  orderedQuantity: Scalars["Int"];
  priceAmount?: Maybe<Scalars["Float"]>;
  productId: Scalars["String"];
  productImageAltTxt?: Maybe<Scalars["String"]>;
  productImageUrl?: Maybe<Scalars["String"]>;
  productTitle: Scalars["String"];
  removedQuantity: Scalars["Int"];
  returnableQuantity: Scalars["Int"];
  sku: Scalars["String"];
  variantId?: Maybe<Scalars["String"]>;
  variantInfo?: Maybe<Array<ShopItemVariantInfo>>;
};

export type ShopItemGrouping = {
  __typename?: "ShopItemGrouping";
  behaviors: Array<Scalars["String"]>;
  displayName: Scalars["String"];
  lineItemIds: Array<Scalars["String"]>;
  slug: Scalars["String"];
};

export type ShopItemReturnRule = {
  __typename?: "ShopItemReturnRule";
  eligible: Scalars["Boolean"];
  /** Reason for ineligibility, ex, ['This item is not eligible for claim'] */
  ineligibleClaimReason?: Maybe<Array<Scalars["String"]>>;
  ineligibleReason?: Maybe<Array<Scalars["String"]>>;
  ineligibleReasonForExchange?: Maybe<Scalars["Boolean"]>;
  ineligibleReasonForReturn?: Maybe<Scalars["Boolean"]>;
  /** If this reason is eligible for claim */
  isEligibleForClaim?: Maybe<Scalars["Boolean"]>;
  /** "return_and_exchange" or "claim" */
  reasonType: Scalars["String"];
  returnReason: Scalars["String"];
};

export type ShopItemVariantInfo = {
  __typename?: "ShopItemVariantInfo";
  name: Scalars["String"];
  value: Scalars["String"];
};

export type ShopNowAbort = {
  __typename?: "ShopNowAbort";
  /** success, error */
  abortStatus: Scalars["String"];
  errors: Array<UserError>;
  /** e.g. £1.23 */
  totalRefundFormatted?: Maybe<Scalars["String"]>;
};

export type ShopNowAbortOption = {
  __typename?: "ShopNowAbortOption";
  refundAmount: Money;
  /** e.g. original_payment, gift_card */
  type: Scalars["String"];
};

export type ShopNowExpiration = {
  __typename?: "ShopNowExpiration";
  expired?: Maybe<Scalars["Boolean"]>;
  formattedAmount?: Maybe<Scalars["String"]>;
};

export type ShopNowSession = {
  __typename?: "ShopNowSession";
  abortOptions?: Maybe<Array<ShopNowAbortOption>>;
  expired: Scalars["Boolean"];
  expiresAt: Scalars["Int"];
  returnStatus?: Maybe<Scalars["String"]>;
  shopNowAbortEnabled?: Maybe<Scalars["Boolean"]>;
  shopNowCheckoutOrderSummaryEnabled?: Maybe<Scalars["Boolean"]>;
  shopNowCredit?: Maybe<Money>;
};

export type ShopOrder = {
  __typename?: "ShopOrder";
  billingCountryCode?: Maybe<Scalars["String"]>;
  billingProvince?: Maybe<Scalars["String"]>;
  billingProvinceCode?: Maybe<Scalars["String"]>;
  billingZip?: Maybe<Scalars["String"]>;
  deliveryProtectionCovered?: Maybe<Scalars["Boolean"]>;
  eligible: Scalars["Boolean"];
  fromAddress1?: Maybe<Scalars["String"]>;
  fromAddress2?: Maybe<Scalars["String"]>;
  fromCity?: Maybe<Scalars["String"]>;
  fromCountryCode?: Maybe<Scalars["String"]>;
  fromFirstName?: Maybe<Scalars["String"]>;
  fromLastName?: Maybe<Scalars["String"]>;
  fromProvince?: Maybe<Scalars["String"]>;
  fromProvinceCode?: Maybe<Scalars["String"]>;
  fromZip?: Maybe<Scalars["String"]>;
  /** Fulfillments for the order, aka shipments or packages */
  fulfillments?: Maybe<Array<ShopOrderFulfillment>>;
  guestLoginEmail: Scalars["String"];
  ineligibleDisplayText?: Maybe<Scalars["String"]>;
  insuranceProvider?: Maybe<Scalars["String"]>;
  items: Array<ShopItem>;
  orderLineItemGroupings: Array<ShopItemGrouping>;
  orderNumber: Scalars["String"];
  presentmentCurrency: Scalars["String"];
  presentmentCurrencyEstimatedUsdConversionRate?: Maybe<Scalars["Float"]>;
  presentmentCurrencySubunitToUnit: Scalars["Int"];
  shopId: Scalars["String"];
  shopifyOrderId: Scalars["String"];
};

export type ShopOrderFulfillment = {
  __typename?: "ShopOrderFulfillment";
  /** Delivery date of the fulfillment */
  deliveredAt?: Maybe<Scalars["ISO8601DateTime"]>;
  /** Line items in the fulfillment */
  fulfillmentLineItems?: Maybe<Array<ShopOrderFulfillmentLineItem>>;
  trackingCompany?: Maybe<Scalars["String"]>;
  trackingNumber?: Maybe<Scalars["String"]>;
};

export type ShopOrderFulfillmentLineItem = {
  __typename?: "ShopOrderFulfillmentLineItem";
  /** Line item GID */
  lineItemGid?: Maybe<Scalars["String"]>;
  /** Quantity of the line item in the fulfillment */
  quantity?: Maybe<Scalars["Int"]>;
};

export type TrackingEvent = {
  __typename?: "TrackingEvent";
  event?: Maybe<Scalars["String"]>;
  eventCity?: Maybe<Scalars["String"]>;
  eventCode?: Maybe<Scalars["String"]>;
  eventCountryCode?: Maybe<Scalars["String"]>;
  eventDate?: Maybe<Scalars["String"]>;
  eventState?: Maybe<Scalars["String"]>;
  eventZip?: Maybe<Scalars["String"]>;
};

export type TrackingInfo = {
  __typename?: "TrackingInfo";
  carrierId?: Maybe<Scalars["String"]>;
  carrierName?: Maybe<Scalars["String"]>;
  estimatedDeliveryDateBegin?: Maybe<Scalars["String"]>;
  estimatedDeliveryDateEnd?: Maybe<Scalars["String"]>;
  id: Scalars["String"];
  locale?: Maybe<Scalars["String"]>;
  narvarStatus?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  trackDetails?: Maybe<Array<TrackingEvent>>;
  trackingNumber?: Maybe<Scalars["String"]>;
  trackingUrl?: Maybe<Scalars["String"]>;
};

export type Translation = {
  __typename?: "Translation";
  category?: Maybe<Scalars["String"]>;
  key: Scalars["String"];
  locale?: Maybe<Scalars["String"]>;
  prelude?: Maybe<Scalars["String"]>;
  suggestion?: Maybe<Scalars["Boolean"]>;
  value?: Maybe<Scalars["String"]>;
};

/** A user-readable error */
export type UserError = {
  __typename?: "UserError";
  /** Unique error identifier */
  code: Scalars["String"];
  /** A description of the error */
  message: Scalars["String"];
};

export type UserPreferences = {
  __typename?: "UserPreferences";
  carriers: Array<Scalars["String"]>;
  locations: Array<Scalars["String"]>;
  profile?: Maybe<ConsumerProfile>;
  returnMethods: Array<Scalars["String"]>;
};

/** Structured Data for Returns User Preferences Input */
export type UserPreferencesInput = {
  carriers: Array<Scalars["String"]>;
  locations: Array<Scalars["String"]>;
  returnMethods: Array<Scalars["String"]>;
};

export type VariantInfo = {
  __typename?: "VariantInfo";
  availabilityStatus?: Maybe<Scalars["String"]>;
  availableForSale?: Maybe<Scalars["Boolean"]>;
  displayName: Scalars["String"];
  imageAlt?: Maybe<Scalars["String"]>;
  imageSrc?: Maybe<Scalars["String"]>;
  inventoryQuantity?: Maybe<Scalars["Int"]>;
  option0?: Maybe<Scalars["String"]>;
  option1?: Maybe<Scalars["String"]>;
  option2?: Maybe<Scalars["String"]>;
  option3?: Maybe<Scalars["String"]>;
  priceAmount?: Maybe<Scalars["Float"]>;
  priceCurrency?: Maybe<Scalars["String"]>;
  priceFormatted?: Maybe<Scalars["String"]>;
  productId?: Maybe<Scalars["String"]>;
  sku?: Maybe<Scalars["String"]>;
  variantId?: Maybe<Scalars["String"]>;
};

export type AddressFragment = {
  __typename?: "Address";
  address1: string;
  address2?: string | null;
  city: string;
  company?: string | null;
  country: string;
  countryCodeV2: string;
  firstName: string;
  lastName: string;
  latitude?: string | null;
  longitude?: string | null;
  name: string;
  phone?: string | null;
  province?: string | null;
  provinceCode?: string | null;
  zipcode?: string | null;
};

export type FeeBreakdownFragment = {
  __typename?: "FeeBreakdown";
  amount: number;
  currencyCode: string;
  formattedValue: string;
  description: string;
  displayWithReturnMethod: boolean;
  shopNowClawback: boolean;
  taxCode?: string | null;
};

export type AmountFragment = {
  __typename?: "Amount";
  amount: number;
  currencyCode: string;
  formattedValue: string;
};

export type ReturnLineItemFragment = {
  __typename?: "ReturnLineItem";
  id: string;
  imageUrl?: string | null;
  name: string;
  productId: string;
  quantity: number;
  title: string;
  variantId: string;
  price: {
    __typename?: "Amount";
    amount: number;
    currencyCode: string;
    formattedValue: string;
  };
  returnReason: { __typename?: "ReturnReasonHash"; id: string; name: string };
};

export type DiscountFragment = {
  __typename?: "Discount";
  targetType: string;
  discountAmount: {
    __typename?: "Amount";
    amount: number;
    currencyCode: string;
    formattedValue: string;
  };
};

export type LineItemFragment = {
  __typename?: "LineItem";
  id?: string | null;
  name: string;
  imageUrl?: string | null;
  productId: string;
  quantity: number;
  title: string;
  variantId: string;
  cost: {
    __typename?: "LineItemCost";
    amountPerQuantity: {
      __typename?: "Amount";
      amount: number;
      currencyCode: string;
      formattedValue: string;
    };
    discountedAmountPerQuantity: {
      __typename?: "Amount";
      amount: number;
      currencyCode: string;
      formattedValue: string;
    };
    subtotal: {
      __typename?: "Amount";
      amount: number;
      currencyCode: string;
      formattedValue: string;
    };
    total: {
      __typename?: "Amount";
      amount: number;
      currencyCode: string;
      formattedValue: string;
    };
  };
  discounts: Array<{
    __typename?: "Discount";
    targetType: string;
    discountAmount: {
      __typename?: "Amount";
      amount: number;
      currencyCode: string;
      formattedValue: string;
    };
  }>;
  price: {
    __typename?: "Amount";
    amount: number;
    currencyCode: string;
    formattedValue: string;
  };
};

export type PaymentFragment = {
  __typename?: "Payment";
  customerPmtId: string;
  paymentClientSecret: string;
  paymentGateway?: string | null;
  paymentGatewayDisplay?: string | null;
  paymentRef?: string | null;
  paymentProvider: string;
  paymentProcessorId: string;
  paymentProcessorPubKey?: string | null;
  value: {
    __typename?: "Amount";
    amount: number;
    currencyCode: string;
    formattedValue: string;
  };
};

export type CartSummaryFragment = {
  __typename?: "CartSummary";
  discountCodes?: Array<string> | null;
  discounts?: Array<{
    __typename?: "Discount";
    targetType: string;
    discountAmount: {
      __typename?: "Amount";
      amount: number;
      currencyCode: string;
      formattedValue: string;
    };
  }> | null;
  subtotal: {
    __typename?: "Amount";
    amount: number;
    currencyCode: string;
    formattedValue: string;
  };
  tax: {
    __typename?: "Amount";
    amount: number;
    currencyCode: string;
    formattedValue: string;
  };
  total: {
    __typename?: "Amount";
    amount: number;
    currencyCode: string;
    formattedValue: string;
  };
  shopNowCredit?: {
    __typename?: "Credit";
    total: {
      __typename?: "Amount";
      amount: number;
      currencyCode: string;
      formattedValue: string;
    };
    used: {
      __typename?: "Amount";
      amount: number;
      currencyCode: string;
      formattedValue: string;
    };
  } | null;
};

export type ReturnCartFragment = {
  __typename?: "ReturnCart";
  cartSummary: {
    __typename?: "CartSummary";
    discountCodes?: Array<string> | null;
    discounts?: Array<{
      __typename?: "Discount";
      targetType: string;
      discountAmount: {
        __typename?: "Amount";
        amount: number;
        currencyCode: string;
        formattedValue: string;
      };
    }> | null;
    subtotal: {
      __typename?: "Amount";
      amount: number;
      currencyCode: string;
      formattedValue: string;
    };
    tax: {
      __typename?: "Amount";
      amount: number;
      currencyCode: string;
      formattedValue: string;
    };
    total: {
      __typename?: "Amount";
      amount: number;
      currencyCode: string;
      formattedValue: string;
    };
    shopNowCredit?: {
      __typename?: "Credit";
      total: {
        __typename?: "Amount";
        amount: number;
        currencyCode: string;
        formattedValue: string;
      };
      used: {
        __typename?: "Amount";
        amount: number;
        currencyCode: string;
        formattedValue: string;
      };
    } | null;
  };
  feeBreakdown: Array<{
    __typename?: "FeeBreakdown";
    amount: number;
    currencyCode: string;
    formattedValue: string;
    description: string;
    displayWithReturnMethod: boolean;
    shopNowClawback: boolean;
    taxCode?: string | null;
  }>;
  lineItems: Array<{
    __typename?: "ReturnLineItem";
    id: string;
    imageUrl?: string | null;
    name: string;
    productId: string;
    quantity: number;
    title: string;
    variantId: string;
    price: {
      __typename?: "Amount";
      amount: number;
      currencyCode: string;
      formattedValue: string;
    };
    returnReason: { __typename?: "ReturnReasonHash"; id: string; name: string };
  }>;
};

export type CartFragment = {
  __typename?: "Cart";
  totalQuantity: number;
  billingAddress: {
    __typename?: "Address";
    address1: string;
    address2?: string | null;
    city: string;
    company?: string | null;
    country: string;
    countryCodeV2: string;
    firstName: string;
    lastName: string;
    latitude?: string | null;
    longitude?: string | null;
    name: string;
    phone?: string | null;
    province?: string | null;
    provinceCode?: string | null;
    zipcode?: string | null;
  };
  cartSummary: {
    __typename?: "CartSummary";
    discountCodes?: Array<string> | null;
    discounts?: Array<{
      __typename?: "Discount";
      targetType: string;
      discountAmount: {
        __typename?: "Amount";
        amount: number;
        currencyCode: string;
        formattedValue: string;
      };
    }> | null;
    subtotal: {
      __typename?: "Amount";
      amount: number;
      currencyCode: string;
      formattedValue: string;
    };
    tax: {
      __typename?: "Amount";
      amount: number;
      currencyCode: string;
      formattedValue: string;
    };
    total: {
      __typename?: "Amount";
      amount: number;
      currencyCode: string;
      formattedValue: string;
    };
    shopNowCredit?: {
      __typename?: "Credit";
      total: {
        __typename?: "Amount";
        amount: number;
        currencyCode: string;
        formattedValue: string;
      };
      used: {
        __typename?: "Amount";
        amount: number;
        currencyCode: string;
        formattedValue: string;
      };
    } | null;
  };
  shippingAddress: {
    __typename?: "Address";
    address1: string;
    address2?: string | null;
    city: string;
    company?: string | null;
    country: string;
    countryCodeV2: string;
    firstName: string;
    lastName: string;
    latitude?: string | null;
    longitude?: string | null;
    name: string;
    phone?: string | null;
    province?: string | null;
    provinceCode?: string | null;
    zipcode?: string | null;
  };
  feeBreakdown: Array<{
    __typename?: "FeeBreakdown";
    amount: number;
    currencyCode: string;
    formattedValue: string;
    description: string;
    displayWithReturnMethod: boolean;
    shopNowClawback: boolean;
    taxCode?: string | null;
  }>;
  lineItems: Array<{
    __typename?: "LineItem";
    id?: string | null;
    name: string;
    imageUrl?: string | null;
    productId: string;
    quantity: number;
    title: string;
    variantId: string;
    cost: {
      __typename?: "LineItemCost";
      amountPerQuantity: {
        __typename?: "Amount";
        amount: number;
        currencyCode: string;
        formattedValue: string;
      };
      discountedAmountPerQuantity: {
        __typename?: "Amount";
        amount: number;
        currencyCode: string;
        formattedValue: string;
      };
      subtotal: {
        __typename?: "Amount";
        amount: number;
        currencyCode: string;
        formattedValue: string;
      };
      total: {
        __typename?: "Amount";
        amount: number;
        currencyCode: string;
        formattedValue: string;
      };
    };
    discounts: Array<{
      __typename?: "Discount";
      targetType: string;
      discountAmount: {
        __typename?: "Amount";
        amount: number;
        currencyCode: string;
        formattedValue: string;
      };
    }>;
    price: {
      __typename?: "Amount";
      amount: number;
      currencyCode: string;
      formattedValue: string;
    };
  }>;
};

export type RefundFragment = {
  __typename?: "Refund";
  refundMethod: string;
  refundMethodDescription: string;
  refundMethodDisplay: string;
  value: {
    __typename?: "Amount";
    amount: number;
    currencyCode: string;
    formattedValue: string;
  };
};

export type ShopNowV2CheckoutQueryVariables = Exact<{
  cartToken: Scalars["String"];
  code: Scalars["String"];
}>;

export type ShopNowV2CheckoutQuery = {
  __typename?: "CustomerQuery";
  shopNowV2Checkout: {
    __typename?: "CheckoutResult";
    data?: {
      __typename?: "Checkout";
      feeBreakdown: Array<{
        __typename?: "FeeBreakdown";
        amount: number;
        currencyCode: string;
        formattedValue: string;
        description: string;
        displayWithReturnMethod: boolean;
        shopNowClawback: boolean;
        taxCode?: string | null;
      }>;
      overallCartSummary: {
        __typename?: "CartSummary";
        discountCodes?: Array<string> | null;
        discounts?: Array<{
          __typename?: "Discount";
          targetType: string;
          discountAmount: {
            __typename?: "Amount";
            amount: number;
            currencyCode: string;
            formattedValue: string;
          };
        }> | null;
        subtotal: {
          __typename?: "Amount";
          amount: number;
          currencyCode: string;
          formattedValue: string;
        };
        tax: {
          __typename?: "Amount";
          amount: number;
          currencyCode: string;
          formattedValue: string;
        };
        total: {
          __typename?: "Amount";
          amount: number;
          currencyCode: string;
          formattedValue: string;
        };
        shopNowCredit?: {
          __typename?: "Credit";
          total: {
            __typename?: "Amount";
            amount: number;
            currencyCode: string;
            formattedValue: string;
          };
          used: {
            __typename?: "Amount";
            amount: number;
            currencyCode: string;
            formattedValue: string;
          };
        } | null;
      };
      payment?: {
        __typename?: "Payment";
        customerPmtId: string;
        paymentClientSecret: string;
        paymentGateway?: string | null;
        paymentGatewayDisplay?: string | null;
        paymentRef?: string | null;
        paymentProvider: string;
        paymentProcessorId: string;
        paymentProcessorPubKey?: string | null;
        value: {
          __typename?: "Amount";
          amount: number;
          currencyCode: string;
          formattedValue: string;
        };
      } | null;
      refund: {
        __typename?: "Refund";
        refundMethod: string;
        refundMethodDescription: string;
        refundMethodDisplay: string;
        value: {
          __typename?: "Amount";
          amount: number;
          currencyCode: string;
          formattedValue: string;
        };
      };
      returnCart: {
        __typename?: "ReturnCart";
        cartSummary: {
          __typename?: "CartSummary";
          discountCodes?: Array<string> | null;
          discounts?: Array<{
            __typename?: "Discount";
            targetType: string;
            discountAmount: {
              __typename?: "Amount";
              amount: number;
              currencyCode: string;
              formattedValue: string;
            };
          }> | null;
          subtotal: {
            __typename?: "Amount";
            amount: number;
            currencyCode: string;
            formattedValue: string;
          };
          tax: {
            __typename?: "Amount";
            amount: number;
            currencyCode: string;
            formattedValue: string;
          };
          total: {
            __typename?: "Amount";
            amount: number;
            currencyCode: string;
            formattedValue: string;
          };
          shopNowCredit?: {
            __typename?: "Credit";
            total: {
              __typename?: "Amount";
              amount: number;
              currencyCode: string;
              formattedValue: string;
            };
            used: {
              __typename?: "Amount";
              amount: number;
              currencyCode: string;
              formattedValue: string;
            };
          } | null;
        };
        feeBreakdown: Array<{
          __typename?: "FeeBreakdown";
          amount: number;
          currencyCode: string;
          formattedValue: string;
          description: string;
          displayWithReturnMethod: boolean;
          shopNowClawback: boolean;
          taxCode?: string | null;
        }>;
        lineItems: Array<{
          __typename?: "ReturnLineItem";
          id: string;
          imageUrl?: string | null;
          name: string;
          productId: string;
          quantity: number;
          title: string;
          variantId: string;
          price: {
            __typename?: "Amount";
            amount: number;
            currencyCode: string;
            formattedValue: string;
          };
          returnReason: {
            __typename?: "ReturnReasonHash";
            id: string;
            name: string;
          };
        }>;
      };
      shopNowCart: {
        __typename?: "Cart";
        totalQuantity: number;
        billingAddress: {
          __typename?: "Address";
          address1: string;
          address2?: string | null;
          city: string;
          company?: string | null;
          country: string;
          countryCodeV2: string;
          firstName: string;
          lastName: string;
          latitude?: string | null;
          longitude?: string | null;
          name: string;
          phone?: string | null;
          province?: string | null;
          provinceCode?: string | null;
          zipcode?: string | null;
        };
        cartSummary: {
          __typename?: "CartSummary";
          discountCodes?: Array<string> | null;
          discounts?: Array<{
            __typename?: "Discount";
            targetType: string;
            discountAmount: {
              __typename?: "Amount";
              amount: number;
              currencyCode: string;
              formattedValue: string;
            };
          }> | null;
          subtotal: {
            __typename?: "Amount";
            amount: number;
            currencyCode: string;
            formattedValue: string;
          };
          tax: {
            __typename?: "Amount";
            amount: number;
            currencyCode: string;
            formattedValue: string;
          };
          total: {
            __typename?: "Amount";
            amount: number;
            currencyCode: string;
            formattedValue: string;
          };
          shopNowCredit?: {
            __typename?: "Credit";
            total: {
              __typename?: "Amount";
              amount: number;
              currencyCode: string;
              formattedValue: string;
            };
            used: {
              __typename?: "Amount";
              amount: number;
              currencyCode: string;
              formattedValue: string;
            };
          } | null;
        };
        shippingAddress: {
          __typename?: "Address";
          address1: string;
          address2?: string | null;
          city: string;
          company?: string | null;
          country: string;
          countryCodeV2: string;
          firstName: string;
          lastName: string;
          latitude?: string | null;
          longitude?: string | null;
          name: string;
          phone?: string | null;
          province?: string | null;
          provinceCode?: string | null;
          zipcode?: string | null;
        };
        feeBreakdown: Array<{
          __typename?: "FeeBreakdown";
          amount: number;
          currencyCode: string;
          formattedValue: string;
          description: string;
          displayWithReturnMethod: boolean;
          shopNowClawback: boolean;
          taxCode?: string | null;
        }>;
        lineItems: Array<{
          __typename?: "LineItem";
          id?: string | null;
          name: string;
          imageUrl?: string | null;
          productId: string;
          quantity: number;
          title: string;
          variantId: string;
          cost: {
            __typename?: "LineItemCost";
            amountPerQuantity: {
              __typename?: "Amount";
              amount: number;
              currencyCode: string;
              formattedValue: string;
            };
            discountedAmountPerQuantity: {
              __typename?: "Amount";
              amount: number;
              currencyCode: string;
              formattedValue: string;
            };
            subtotal: {
              __typename?: "Amount";
              amount: number;
              currencyCode: string;
              formattedValue: string;
            };
            total: {
              __typename?: "Amount";
              amount: number;
              currencyCode: string;
              formattedValue: string;
            };
          };
          discounts: Array<{
            __typename?: "Discount";
            targetType: string;
            discountAmount: {
              __typename?: "Amount";
              amount: number;
              currencyCode: string;
              formattedValue: string;
            };
          }>;
          price: {
            __typename?: "Amount";
            amount: number;
            currencyCode: string;
            formattedValue: string;
          };
        }>;
      };
    } | null;
    errors: Array<{ __typename?: "UserError"; code: string; message: string }>;
  };
};

export type SubmitShopNowV2CheckoutMutationVariables = Exact<{
  checkout: CheckoutCompleteInput;
}>;

export type SubmitShopNowV2CheckoutMutation = {
  __typename?: "CustomerMutation";
  shopNowV2Checkout: {
    __typename?: "CheckoutCompleteResult";
    data?: { __typename?: "CheckoutComplete"; message: string } | null;
    errors: Array<{ __typename?: "UserError"; code: string; message: string }>;
  };
};

export type ApplyDiscountCodeMutationVariables = Exact<{
  cartToken: Scalars["String"];
  code: Scalars["String"];
  couponCodes: Array<Scalars["String"]> | Scalars["String"];
}>;

export type ApplyDiscountCodeMutation = {
  __typename?: "CustomerMutation";
  applyDiscountCode: {
    __typename?: "DiscountCodeResult";
    data?: string | null;
    errors: Array<{ __typename?: "UserError"; code: string; message: string }>;
  };
};

export const AmountFragmentDoc = gql`
  fragment Amount on Amount {
    amount
    currencyCode
    formattedValue
  }
`;
export const PaymentFragmentDoc = gql`
  fragment Payment on Payment {
    customerPmtId
    paymentClientSecret
    paymentGateway
    paymentGatewayDisplay
    paymentRef
    paymentProvider
    paymentProcessorId
    paymentProcessorPubKey
    value {
      ...Amount
    }
  }
  ${AmountFragmentDoc}
`;
export const DiscountFragmentDoc = gql`
  fragment Discount on Discount {
    discountAmount {
      ...Amount
    }
    targetType
  }
  ${AmountFragmentDoc}
`;
export const CartSummaryFragmentDoc = gql`
  fragment CartSummary on CartSummary {
    discountCodes
    discounts {
      ...Discount
    }
    subtotal {
      ...Amount
    }
    tax {
      ...Amount
    }
    total {
      ...Amount
    }
    shopNowCredit {
      total {
        ...Amount
      }
      used {
        ...Amount
      }
    }
  }
  ${DiscountFragmentDoc}
  ${AmountFragmentDoc}
`;
export const FeeBreakdownFragmentDoc = gql`
  fragment FeeBreakdown on FeeBreakdown {
    amount
    currencyCode
    formattedValue
    description
    displayWithReturnMethod
    shopNowClawback
    taxCode
  }
`;
export const ReturnLineItemFragmentDoc = gql`
  fragment ReturnLineItem on ReturnLineItem {
    id
    imageUrl
    name
    price {
      ...Amount
    }
    productId
    quantity
    returnReason {
      id
      name
    }
    title
    variantId
  }
  ${AmountFragmentDoc}
`;
export const ReturnCartFragmentDoc = gql`
  fragment ReturnCart on ReturnCart {
    cartSummary {
      ...CartSummary
    }
    feeBreakdown {
      ...FeeBreakdown
    }
    lineItems {
      ...ReturnLineItem
    }
  }
  ${CartSummaryFragmentDoc}
  ${FeeBreakdownFragmentDoc}
  ${ReturnLineItemFragmentDoc}
`;
export const AddressFragmentDoc = gql`
  fragment Address on Address {
    address1
    address2
    city
    company
    country
    countryCodeV2
    firstName
    lastName
    latitude
    longitude
    name
    phone
    province
    provinceCode
    zipcode
  }
`;
export const LineItemFragmentDoc = gql`
  fragment LineItem on LineItem {
    cost {
      amountPerQuantity {
        ...Amount
      }
      discountedAmountPerQuantity {
        ...Amount
      }
      subtotal {
        ...Amount
      }
      total {
        ...Amount
      }
    }
    discounts {
      ...Discount
    }
    id
    name
    imageUrl
    price {
      ...Amount
    }
    productId
    quantity
    title
    variantId
  }
  ${AmountFragmentDoc}
  ${DiscountFragmentDoc}
`;
export const CartFragmentDoc = gql`
  fragment Cart on Cart {
    billingAddress {
      ...Address
    }
    cartSummary {
      ...CartSummary
    }
    shippingAddress {
      ...Address
    }
    totalQuantity
    feeBreakdown {
      ...FeeBreakdown
    }
    lineItems {
      ...LineItem
    }
  }
  ${AddressFragmentDoc}
  ${CartSummaryFragmentDoc}
  ${FeeBreakdownFragmentDoc}
  ${LineItemFragmentDoc}
`;
export const RefundFragmentDoc = gql`
  fragment Refund on Refund {
    refundMethod
    refundMethodDescription
    refundMethodDisplay
    value {
      ...Amount
    }
  }
  ${AmountFragmentDoc}
`;
export const ShopNowV2CheckoutDocument = gql`
  query shopNowV2Checkout($cartToken: String!, $code: String!) {
    shopNowV2Checkout(cartToken: $cartToken, code: $code) {
      data {
        feeBreakdown {
          ...FeeBreakdown
        }
        overallCartSummary {
          ...CartSummary
        }
        payment {
          ...Payment
        }
        refund {
          ...Refund
        }
        returnCart {
          ...ReturnCart
        }
        shopNowCart {
          ...Cart
        }
      }
      errors {
        code
        message
      }
    }
  }
  ${FeeBreakdownFragmentDoc}
  ${CartSummaryFragmentDoc}
  ${PaymentFragmentDoc}
  ${RefundFragmentDoc}
  ${ReturnCartFragmentDoc}
  ${CartFragmentDoc}
`;

/**
 * __useShopNowV2CheckoutQuery__
 *
 * To run a query within a React component, call `useShopNowV2CheckoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useShopNowV2CheckoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopNowV2CheckoutQuery({
 *   variables: {
 *      cartToken: // value for 'cartToken'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useShopNowV2CheckoutQuery(
  baseOptions: Apollo.QueryHookOptions<
    ShopNowV2CheckoutQuery,
    ShopNowV2CheckoutQueryVariables
  > &
    (
      | { variables: ShopNowV2CheckoutQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ShopNowV2CheckoutQuery,
    ShopNowV2CheckoutQueryVariables
  >(ShopNowV2CheckoutDocument, options);
}
export function useShopNowV2CheckoutLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ShopNowV2CheckoutQuery,
    ShopNowV2CheckoutQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ShopNowV2CheckoutQuery,
    ShopNowV2CheckoutQueryVariables
  >(ShopNowV2CheckoutDocument, options);
}
export function useShopNowV2CheckoutSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ShopNowV2CheckoutQuery,
        ShopNowV2CheckoutQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ShopNowV2CheckoutQuery,
    ShopNowV2CheckoutQueryVariables
  >(ShopNowV2CheckoutDocument, options);
}
export type ShopNowV2CheckoutQueryHookResult = ReturnType<
  typeof useShopNowV2CheckoutQuery
>;
export type ShopNowV2CheckoutLazyQueryHookResult = ReturnType<
  typeof useShopNowV2CheckoutLazyQuery
>;
export type ShopNowV2CheckoutSuspenseQueryHookResult = ReturnType<
  typeof useShopNowV2CheckoutSuspenseQuery
>;
export type ShopNowV2CheckoutQueryResult = Apollo.QueryResult<
  ShopNowV2CheckoutQuery,
  ShopNowV2CheckoutQueryVariables
>;
export const SubmitShopNowV2CheckoutDocument = gql`
  mutation submitShopNowV2Checkout($checkout: CheckoutCompleteInput!) {
    shopNowV2Checkout(checkout: $checkout) {
      data {
        message
      }
      errors {
        code
        message
      }
    }
  }
`;
export type SubmitShopNowV2CheckoutMutationFn = Apollo.MutationFunction<
  SubmitShopNowV2CheckoutMutation,
  SubmitShopNowV2CheckoutMutationVariables
>;

/**
 * __useSubmitShopNowV2CheckoutMutation__
 *
 * To run a mutation, you first call `useSubmitShopNowV2CheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitShopNowV2CheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitShopNowV2CheckoutMutation, { data, loading, error }] = useSubmitShopNowV2CheckoutMutation({
 *   variables: {
 *      checkout: // value for 'checkout'
 *   },
 * });
 */
export function useSubmitShopNowV2CheckoutMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubmitShopNowV2CheckoutMutation,
    SubmitShopNowV2CheckoutMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SubmitShopNowV2CheckoutMutation,
    SubmitShopNowV2CheckoutMutationVariables
  >(SubmitShopNowV2CheckoutDocument, options);
}
export type SubmitShopNowV2CheckoutMutationHookResult = ReturnType<
  typeof useSubmitShopNowV2CheckoutMutation
>;
export type SubmitShopNowV2CheckoutMutationResult =
  Apollo.MutationResult<SubmitShopNowV2CheckoutMutation>;
export type SubmitShopNowV2CheckoutMutationOptions = Apollo.BaseMutationOptions<
  SubmitShopNowV2CheckoutMutation,
  SubmitShopNowV2CheckoutMutationVariables
>;
export const ApplyDiscountCodeDocument = gql`
  mutation applyDiscountCode(
    $cartToken: String!
    $code: String!
    $couponCodes: [String!]!
  ) {
    applyDiscountCode(
      cartToken: $cartToken
      code: $code
      couponCodes: $couponCodes
    ) {
      data
      errors {
        code
        message
      }
    }
  }
`;
export type ApplyDiscountCodeMutationFn = Apollo.MutationFunction<
  ApplyDiscountCodeMutation,
  ApplyDiscountCodeMutationVariables
>;

/**
 * __useApplyDiscountCodeMutation__
 *
 * To run a mutation, you first call `useApplyDiscountCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyDiscountCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyDiscountCodeMutation, { data, loading, error }] = useApplyDiscountCodeMutation({
 *   variables: {
 *      cartToken: // value for 'cartToken'
 *      code: // value for 'code'
 *      couponCodes: // value for 'couponCodes'
 *   },
 * });
 */
export function useApplyDiscountCodeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApplyDiscountCodeMutation,
    ApplyDiscountCodeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ApplyDiscountCodeMutation,
    ApplyDiscountCodeMutationVariables
  >(ApplyDiscountCodeDocument, options);
}
export type ApplyDiscountCodeMutationHookResult = ReturnType<
  typeof useApplyDiscountCodeMutation
>;
export type ApplyDiscountCodeMutationResult =
  Apollo.MutationResult<ApplyDiscountCodeMutation>;
export type ApplyDiscountCodeMutationOptions = Apollo.BaseMutationOptions<
  ApplyDiscountCodeMutation,
  ApplyDiscountCodeMutationVariables
>;
